export const SET_STEP = "SET_STEP";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_VALIDS = "UPDATE_VALIDS";
export const SET_ATTEMPTED = "SET_ATTEMPTED";
export const SET_SHIPPING_LOCATIONS = "SET_SHIPPING_LOCATIONS";
export const SET_CONCESSION_INFO = "SET_CONCESSION_INFO";
export const SET_START_FORM = "SET_START_FORM";

export function setStep(step) {
    return {
        type: SET_STEP,
        step
    }
}

export function updateOrder(order) {
    return {
        type: UPDATE_ORDER,
        order
    }
}

export function updateValids(valids) {
    return {
        type: UPDATE_VALIDS,
        valids
    }
}

export function setAttempted(toggle) {
    return {
        type: SET_ATTEMPTED,
        toggle
    }
}

export function setShippingLocations(shipping_locations) {
    return {
        type: SET_SHIPPING_LOCATIONS,
        shipping_locations
    }
}

export function setConcessionInfo(concession_info) {
    return {
        type: SET_CONCESSION_INFO,
        concession_info
    }
}

export function setStartForm(toggle) {
    return {
        type: SET_START_FORM,
        toggle
    }
}